import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Login from '../view/auth'
import Dashboard from '../view/Dashboard'
import PublicRoute from '../components/PublicRoute'
import PrivateRoute from '../components/PrivateRoutes'
import ForgotPassword from '../view/auth/ForgetPassword'
import ResetPassword from '../view/auth/ResetMyPassword'
import MobileMenu from '../components/MobileMenu'
import Terms from '../view/Terms'
import About from '../view/About'
import AdminSettings from '../view/AdminSettings'
import IntegrationsHub from '../view/IntegrationsHub'

function Router() {
  return (
    <Routes>
      <Route
        path='/'
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />

      <Route
        path='/esqueci-minha-senha'
        element={
          <PublicRoute>
            <ForgotPassword />
          </PublicRoute>
        }
      />
      <Route
        path='/reset-password'
        element={
          <PublicRoute>
            <ResetPassword />
          </PublicRoute>
        }
      />
      <Route
        path='/dashboard'
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route path='/termos-de-uso' element={<Terms />} />
      <Route
        path='/sobre'
        element={
          <PrivateRoute>
            <About />
          </PrivateRoute>
        }
      />
      <Route
        path='/painel'
        element={
          <PrivateRoute>
            <MobileMenu />
          </PrivateRoute>
        }
      />
      <Route
        path='/configuracoes'
        element={
          <PrivateRoute>
            <AdminSettings />
          </PrivateRoute>
        }
      />
      <Route
        path='/integracoes'
        element={
          <PrivateRoute>
            <IntegrationsHub />
          </PrivateRoute>
        }
      />
    </Routes>
  )
}

export default Router
